export default {
  message: {
    "error": "Xato yuz berdi!",
    "Sorrysomeerrorsoccurred": "Uzr, bir nechta xatolar yuz berdi",
    "quit": "Chiqish",
    "language": "Til",
    "Youcanchangethelanguagehere": "Tilni bu yerda o'zgartirishingiz mumkin!",
    "current": "Hozirgi",
    "home": "Bosh sahifa",
    "friends": "Dostlar",
    "wallet": "Hamyon",
    "aboutus": "Biz haqimizda",
    "Sharewithfriends": "Dostlar bilan bo'lishing",
    "copyFailure": "Qaytish nusxalash",
    "copySuccess": "Nusxalash muvaffaqiyatli",
    "Claimreward": "Inshootni oling",
    "DailyLogin": "Kunlik kirish",
    "noInvitationsYet": "Hali takliflar yo'q",
    "LoadMore": "Batafsil yuklash",
    "WatchAD": "Reklamani tomosha qiling",
    "continue": "Davom eting",
    "Congratulations": "Tabriklaymiz",
    "MyFriends": "Mening Do'stlarim",
    "Invitefriends": "Dostlarni taklif qiling",
    "Invitepremiumfriends": "Premium do'stlarni taklif qiling",
    "DailyTasks": "Kunlik vazifalar",
    "inviteDesc": "Har bir taklif qilgan do'stingiz uchun +{num} ${name}",
    "DailyTasksDesc": "Batafsil ko'proq ${name} olish uchun vazifalarni bajaringsiz",
    "SponsorsandPartners": "Homiylar va Hamkorlar",
    "Receivingwallet": "Olingan hamyon",
    "Enterwalletaddress": "{name} hamyon manzilini kiriting",
    "Claim": "Oling",
    "Booster": "Tezlashtiruvchi",
    "RentPeriod": "Ijarada vaqt",
    "days30": "30 kun",
    "days": "kun",
    "Dailyprofit": "Kunlik foyda",
    "Totalprofit": "Umumiy foyda",
    "Quantity": "Miqdor",
    "RentPrice": "Ijara narxi",
    "RentMiner": "Minerni ijaraga oling",
    "Insufficient": "Yetarli emas ${name}",
    "InsufficientMsg": "{num} ${name1} kerak, do'stlarni taklif qiling yoki ko'proq ${name2} olish uchun vazifalarni bajaringsiz.",
    "Settings": "Sozlamalar",
    "copyid": "ID nusxalang",
    "UpgradeSuccessfully": "Muvofaqiyatli yangilandi",
    "Name": "Ism",
    "userinfo": "Foydalanuvchi ma'lumotlari",
    "disconnect": "Ulanishni uzish",
    "Startmining": "Kazishishni boshlang",
    "Welcome": "{name} ga xush kelibsiz",
    "Withdrawal": "Pulni chiqarish",
    "Minimumamount": "Minimal miqdor",
    "Networkfee": "Tarmoq to'lovi",
    "Enteramount": "Miqdorni kiriting",
    "Submit": "Jo'natish",
    "MinimumTip": "Olingan miqdor juda kichik. Eng kam olingan miqdor: {num}",
    "MaximumTip": "Yetarli miqdor emas, olib ketishingiz mumkin bo'lgan maksimal miqdor: {num}",
    "SubmittedTip": "Jo'natildi, 30-60 ish kuni ichida qayta ishlanishi kutilmoqda",
    "WebSubmittedTip": "Jo'natildi, 24-48 soat ichida qayta ishlanishi kutilmoqda",
    "WithdrawStatus": "Holat",
    "Submissiontime": "Jo'natish vaqti",
    "WithdrawAwaitTip": "* Bu 30-60 ish kuni davom etishi taxmin qilinmoqda. Ko'proq do'stlarni taklif qilish ko'rib chiqish jarayonini tezlashtirishi mumkin.",
    "WebWithdrawAwaitTip": "* Bu 24-48 soat davom etishi taxmin qilinmoqda. Ko'proq do'stlarni taklif qilish ko'rib chiqish jarayonini tezlashtirishi mumkin.",
    "Processing": "Qayta ishlanmoqda",
    "Success": "Muvoffaqqiyat",
    "Rejection": "Rad etish",
    "Amount": "Miqdor",
    "Numberoffriends": "Do'stlar soni: {now}/{limit}",
    "InviteTip": "Birinchi olingan miqdorning olish uchun {limit} do'stni mining ilovasiga taklif qilishingiz kerak.",
    "openonphone": "Bu havolani telefoningizda oching.",
    "claimTip": "Olish uchun miqdor juda kichik. Eng kam olinadigan miqdor: {num}",
    "WalletBalance": "Hamyon Balansi",
    "Withdraw": "Olib ketish",
    "SetWalletAddress": "Hamyon Manzilini o'rnating",
    "WithdrawalRecord": "Olib ketish yozuvi",
    "Norecords": "Yozuvlar yo'q",
    "Whatis": "{name} nima?",
    "All": "Hammasi",
    "save": "Saqlash",
    "successWithdrawal": "Olib ketish {num} qabul qilindi",
    "secondsago": "{time} soniya avval",
    "Loading": "Yuklanmoqda...",
    "PaymentConfirming": "Tranzaksiya holatini tekshirish...",
    "Check": "Tekshirish",
    "CheckFail": "Tranzaksiya bajarilmadi. Iltimos, 5 soniyadan keyin yana tekshiring.",
    "Addname": "'{name}' ni ismingizga qo'shing",
    "Restattcheck": "Tekshirish uchun ilovani qaytadan ishga tushiring",
    "Copyname": "'{name}' ni nusxalash",
    "SubmissionFailed": "Jo'natish muvaffaqiyatsiz bo'ldi, iltimos, keyinroq qaytadan urinib ko'ring",
    "WithdrawalReview": "Olib ketish ko'rib chiqilishi",
    "shop": "Do'konda",
    "topurchase": "Sotib olish uchun do'konga boring",
    "shopDesc": "Cheklangan mavjudlik - uni yo'qolmasidan oldin oling!",
    "select_payment_method": "To'lov usulini tanlang",
    "total_amount": "Jami miqdor",
    "creating_order": "Buyurtma yaratilmoqda...",
    "order_created": "Buyurtma yaratildi",
    "order_status": "Buyurtma holati",
    "claim": "Ozod qilish",
    "payment_success": "To'lov muvaffaqiyatli",
    "payment_failed": "To'lov muvaffaqiyatsiz",
    "payment_cancelled": "To'lov bekor qilindi",
    "opening_payment": "To'lovni ochish...",
    "payment_status": "To'lov holati",
    "create_order_failed": "Buyurtma yaratishda xato yuz berdi",
    "creating_ton_order": "TON buyurtmasini yaratish...",
    "next_step": "Keyingi qadam",
    "use_ton_payment": "TON to'lovdan foydalaning",
    "start_transaction": "Operatsiyani boshlang",
    "connect_wallet": "Hamyonni ulash",
    "address": "Manzil",
    "amount_ton": "Miqdor TON",
    "copy": "Nusxa olish",
    "amount": "Miqdor",
    "wallet_address": "Hamyon manzili",
    "comment_memo": "Izoh eslatmasi",
    "you_can_choose_to_connect_wallet_to_pay": "To'lovni amalga oshirish uchun hamyonni ulashingiz mumkin",
    "or_manually_transfer_to_the_above_address": "Yoki yuqoridagi manzilga qo'lda o'tkazib yuborishingiz mumkin (miqdor va eslatma aniq bir xil bo'lishi kerak)",
    "transaction_success": "Operatsiya muvaffaqiyatli",
    "transaction_failed": "Operatsiya muvaffaqiyatsiz",
    "transaction_error": "Operatsiya xatoligi",
    "transaction_status": "Operatsiya holati",
    "transaction_id": "Operatsiya IDsi",
    "transaction_amount": "Operatsiya miqdori",
    "transaction_status_desc": "Operatsiya holati ta'rifi",
    "payment_status_tip": "Iltimos, to'lov tasdiqlanishini kuting",
    "Applyforwithdrawal": "Olingan mablag'larni yechib olish uchun murojaat qiling",
    "Withdrawalunlock": "Yechib olishni ochish",
    "Close": "Yoping",
    "Delivering": "Yetkazib berish jarayonida",
    "Duetothelargenumber": "Qabul qiluvchilar soni katta ekanligi sababli, sizning airdrop'ingiz 15-20 ish kunida yetib kelishi kutilyapti",
    "WithdrawalunlockTip": "Siz yechib olishni ochish uchun vazifalarni bajarish/hamyonlarni bog'lash uchun {num} do'stlarni taklif qilishingiz kerak",
    "select_network": "Tarmoqni tanlang",
    "confirm": "tasdiqlash",
    "switching_network": "Tarmoq o'zgartirilmoqda...",
    "network_switched": "Tarmoq o'zgartirildi",
    "use_usdt_payment": "USDT to'lovi foydalaning",
    "or_manually_transfer_to_the_above_address_usdt": "Yuqoridagi manzilga qo'lda o'tkazing (mablag' va manzil aynan bir xil bo'lishi kerak)",
    "chain_type": "Tarmoq",
    "check_transaction_status": "Transaksiya holatini tekshiring",
    "transaction_wait": "Transaksiya amalga oshmoqda. Ilovadan chiqishingiz mumkin. Tugallangach, sizga xabar yuboriladi.",
    "twa_pay_tip_with_memo": "Iltimos, manzil, miqdor va eslatmani o'tkazma uchun bir xil ekanligiga ishonch hosil qiling.",
    "twa_pay_tip": "Iltimos, manzil va miqdorning o'tkazma uchun to'g'ri ekanligiga ishonch hosil qiling.",
    "creating_usdt_order": "USDT buyurtmasi yaratilmoqda...",
    "affiliate_programs": "Affiliat dasturlari",
    "affiliate_programs_description": "Dostlaringizni qazib olish ilovasiga taklif qiling va mukofot oling.",
    "commission_details": "Komissiya tafsilotlari",
    "no_commission_records": "Hech qanday komissiya yozuvlari yo'q",
    "commission_list": "Komissiya ro'yxati",
    "input_amount": "Miqdor kiritish",
    "max": "Eng ko'p",
    "commission_input_amount": "Komissiya miqdorini kiriting",
    "min_commission": "Minimum pul olish miqdori {num}",
    "WithdrawalSuccess": "Pul olish muvaffaqiyatli",
    "WithdrawalFailed": "Pul olish muvaffaqiyatsiz",
    "WithdrawalProcessing": "Pul olish jarayonida",
    "award": "Mukofot",
    "level": "Daraja",
    "Share_to_group": "Guruhga ulashish",
    "Exchange": "Almashish",
    "balance_not_enough": "Balans etarli emas, faqat {num} {coin} almasha olasiz",
    "exchange_fail": "Almashish muvaffaqiyatsiz",
    "exchange_success": "Almashish muvaffaqiyatli",
    "you_will_receive": "Siz {name} olasiz",
    "ShareToGroups": "Guruhlarga ulashish",
    "Numberofgroups": "Guruhlar soni: {now}/{limit}",
    "Confirm": "Tasdiqlash",
    "ShareToGroupsDesc": "Kengaytirilgan {name} olish uchun guruhlarga ulashing",
    "TokenAddress": "Iltimos, foydalanish uchun ma'lumotlarni kiriting, masalan, almashuv ID yoki USDT manzili",
    "CashAddress": "Iltimos, foydalanish uchun ma'lumotlarni kiriting, masalan, bank karta raqami yoki USDT manzili",
    "Cancel": "Bekor qilish",
    "min_withdrawal_amount": "Minimal pul olish miqdori {num} {coin}",
    "max_withdrawal_amount": "maksimal pul olish miqdori {num} {coin}",
    "withdrawal_failed": "Pul olish amalga oshmadi",
    "withdrawal_success": "Olingan mablag' muvaffaqiyatli",
    "PayNow": "Hoziroq to'laymiz",
    "PaySkip": "{num} to'lash orqali yechimni tezda oching",
    "NumberofGroups": "Guruhlar soni: {now}/{limit}",
    "SendMessage": "Xabar jo'natish",
    "NumberofShares": "Ulushlar soni: {now}/{limit}",
    "NumberofTasks": "Vazifalar soni: {now}/{limit}",
    "CompleteTask": "Vazifani bajaring",
    "PleaseEnterValidAmount": "Iltimos, to'g'ri miqdorni kiriting",
    "PleaseEnterValidEmail": "Iltimos, to'g'ri elektron pochta manzilini kiriting",
    "Feedback": "Fikringiz",
    "Inputfeedbackcontent": "Fikr mulohaza tarkibini kiriting",
    "Submitfeedback": "Fikr mulohaza yuboring",
    "Pleaseenteravalidemailaddress": "Iltimos, to'g'ri elektron pochta manzilini kiriting",
    "Pleaseenteryouremailaddress": "Iltimos, elektron pochta manzilingizni kiriting",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "Siz bugun allaqachon fikr bildirdingiz, iltimos, ertaga qaytaring",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Fikr mulohaza muvaffaqiyatli yuborildi, qimmatli fikrlaringiz uchun rahmat",
    "Feedback_submission_failed_please_retry": "Fikr mulohaza yuborish muvaffaqiyatsiz bo'ldi, iltimos, qaytadan urinib ko'ring",
    "ContactUs": "Biz bilan bog'laning",
    "XRPAddress": "Iltimos, aktivlashtirilgan XRP zanjiri hamyon manzilini (MEMO qo'shib) to'ldiring, aks holda siz naqd pulni chiqarib ololmaysiz.",
    "Accelerated": "Tezlashtirilgan",
    "Accelerated_withdrawals_success": "Tezlashtirilgan pul o'tkazmalari muvaffaqiyatli",
    "login": "Kirish",
    "register": "Ro'yxatdan o'tish",
    "login_with_google": "Google bilan kirish",
    "or": "YOKI",
    "email": "Email",
    "password": "Parol",
    "no_account": "Hisobingiz yo'qmi",
    "click_to_go": "Olish uchun bosing",
    "have_account": "Hisobingiz bormi",
    "go_to": "O'ting",
    "invite_code": "Taklif kodi",
    "optional": "Ixtiyoriy",
    "google_login_not_ready": "Google kirishi tayyor emas, iltimos keyinroq qayta urinib ko'ring",
    "password_too_long": "Parol juda uzun",
    "weak": "Zayif",
    "medium": "O'rta",
    "strong": "Chuqur",
    "login_success": "Kirish muvaffaqiyatli",
    "login_failed": "Kirishning muvaffaqiyatsizligi",
    "please_input_email": "Iltimos email manzilingizni kiriting",
    "invalid_email": "Yaroqsiz email formati",
    "please_input_password": "Iltimos parolingizni kiriting",
    "password_length_6_to_16": "Parol 6-16 belgidan iborat bo'lishi kerak",
    "account_or_password_error": "Hisob yoki parol xatosi",
    "register_success": "Ro'yxatdan o'tish muvaffaqiyatli",
    "register_failed": "Ro'yxatdan o'tish muvaffaqiyatsizligi",
    "save_error": "Saqlash xatosi, iltimos, keyinroq qayta urinib ko'ring",
    "ShareToFriends": "Dostlar bilan ulashing",
    "login_first": "Iltimos, avval kirishingizni talab qilamiz",
    "WalletBscError": "❌ Noto'g'ri BNB Chain hamyon manzili.",
    "DownloadWallet": "Hamyonni yuklab olish",
    "AddToHomeScreen": "Bosh sahifaga {appName} qo'shing",
    "TapShareInToolbar": "Asboblar panelida bosing",
    "SelectAddToHomeScreen": "Bosh sahifaga qo'shishni tanlang",
    "OpenToolbar": "Asboblar panelini oching",
    "ClaimFailed": "Mukofotni qabul qilish amalga oshmadi, iltimos, keyinroq qayta urinib ko'ring",
    "guest_login": "Mehmon kirish",
    "please_input_phone": "Iltimos, telefon raqamingizni kiriting",
    "email_error_1": "Iltimos, elektron pochtangizni kiriting",
    "email_error_2": "Iltimos, to'g'ri elektron pochta manzilini kiriting",
    "email_error_3": "Mehmon elektron pochtasi ruxsat etilmaydi, iltimos, haqiqiy elektron pochta foydalaning",
    "phone": "Telefon",
    "phone_error_1": "Iltimos, telefon raqamingizni kiriting",
    "phone_error_2": "Iltimos, to'g'ri telefon raqamini kiriting",
    "update_info": "Ma'lumotlarni yangilash",
    "update_success": "Yangilash muvaffaqiyatli",
    "update_failed": "Yangilash muvaffaqiyatsiz, iltimos, keyinroq qaytadan urinib ko'ring",
    "cancel": "Bekor qilish",
    "guest_credentials_title": "Hisob Ma'lumotlari",
    "guest_credentials_warning": "Hisobingiz va parolingizni saqlash uchun skrinshot oling. Agar yo'qotilsa, daromadlaringizni qaytarib olish mumkin emas!",
    "i_have_saved": "Men saqladim",
    "account": "Hisob",
    "view_credentials": "Ma'lumotlarni Ko'rish",
    "miner_max_reached": "Siz ushbu minerning maksimal soniga yetdingiz"
}};